<template>
  <div style="margin-bottom: 0px; z-index: 200; position: fixed; width: 100%">
    <v-app-bar  color="#425058" height="55" style="color: white;" dense app clipped-left>
        <v-img
          src="@/assets/TBetMake_Logo-RGB-Hori-noTAG.svg"
          height="40"
          width="50"
          position="left"
          contain
          style="padding: 5px"
        >
        </v-img>
      <v-toolbar-items v-if="isUserLoggedIn">
        <v-btn to="/" class="white--text" text>Home</v-btn>
        <v-btn class="font-weight-bold navigation-signout" @click="logout()" color="#425058"
        style="color:#fff;" elevation="0"><v-icon class="ml-2">mdi-logout</v-icon></v-btn>
        <!--
        <amplify-authenticator >
          <div v-if="isUserLoggedIn && user">
            <div>Hello, {{ user.username }}</div>
          </div>
          <amplify-sign-out></amplify-sign-out>
        </amplify-authenticator>-->
      </v-toolbar-items>
    </v-app-bar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'AppNavigation',
  props: {
    clickFeature: Function,
    fullScreenMode: Function,
    fullscreen: Boolean,
  },
  data: () => ({
    loggedIn: false,
    accessToken: null,
    signInModal: false,
  }),

  computed: {
    ...mapGetters([ 'getIsUserLoggedIn']),
    isUserLoggedIn() {
      return this.getIsUserLoggedIn;
    },
  },
  methods: {
    ...mapActions(['authState','Logout']),
    logout() {
      this.Logout();
    },
  },
};
</script>

<style scoped>
.controlPanel {
  margin-left: 200px;
  position: absolute;
}
</style>
